import { AfterViewChecked, Component, ContentChild, OnInit, ViewChild } from "@angular/core";
import { NgbActiveModal, NgbDate, NgbDatepicker, NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { NgxUiLoaderService } from "ngx-ui-loader";
import * as moment from 'moment';
import { BookingService } from "src/app/core/services/booking.service";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
declare let gtag: (property: string, value: any, configs: any) => {};
@Component({
    selector: 'app-datepicker',
    templateUrl: './datepicker.component.html'
})
export class DatepickerComponent  implements OnInit, AfterViewChecked{
    dateModel: NgbDateStruct;

    public myMoment: string;
    public btnCalendar = 1;

    @ViewChild('dp') datepicker: NgbDatepicker;

    outsideDays;
    minimumDate;
    maximumDate;
    disabledDays;
    constructor(private bookingService: BookingService,
        private activeModal: NgbActiveModal,
        private router: Router,
        private ngxLoader: NgxUiLoaderService,
        private toastr: ToastrService
    ) {
    }
    ngAfterViewChecked(): void {
        this.ngxLoader.startLoader('selectType-loader2');
    }
    ngOnInit(): void {
        this.setCalendarConfig();
    }

    /* This sets the initial calendar configuration > No sundays and min/max date range */
    public setCalendarConfig() {
        
        const currentDate = new Date();
        const day = currentDate.getDate();
        const month = currentDate.getMonth() + 1;
        const year = currentDate.getFullYear();
        const lastDate = new Date(year, month, 0);
        this.minimumDate = { year, month, day }; // Minimum available date
        this.maximumDate = { year: year, month: month, day: lastDate.getDate() }; // Maximum available date
        this.outsideDays = 'hidden';

        // sundays are disabled
        this.disabledDays = (date: NgbDate) => {
            const d = new Date(date.year, date.month - 1, date.day);
            return d.getDay() === 0;
        };
    }

    selectToday() {
        const now = new Date();
        this.dateModel = {
            year: now.getFullYear(),
            month: now.getMonth() + 1,
            day: now.getDate(),
        };
        this.btnCalendar = 0;
    }

    onDateSelect(event) {
        this.btnCalendar = 0;
    }
    getCalendarAvailability(event, includeNextMonth = false) {
        console.log(this.datepicker);
        const month = event.month;
        const year = event.year;
        const lastDateInMonth = new Date(year, month, 0);
        const systemDate = new Date();
        this.bookingService.getCalendarAvailability(month, year).subscribe((response) => {
            if (response.message && response.status) {
                this.disabledDays = (date: NgbDate) => {
                    const d = new Date(date.year, date.month - 1, date.day);
                    return !(response.message.find(x => x.day === (moment(d)).format('YYYY-MM-DD')) !== null && response.message.find(x => x.day === (moment(d)).format('YYYY-MM-DD')) !== undefined);
                };

                if (response.message.length > 0) {
                    let firstAvailabilityDay = moment(response.message[0].day);
                    this.dateModel = { year: year, month: month, day: firstAvailabilityDay.date() };
                    this.btnCalendar = 0;
                    if (includeNextMonth)
                        this.datepicker.navigateTo(this.dateModel);
                }
                else {
                    if (lastDateInMonth.getDate() == systemDate.getDate() && !includeNextMonth) {
                        includeNextMonth = true;
                        event.month += 1;
                        if (event.month > 12) {
                            event.month = 1;
                            event.year += 1;
                        }
                        return this.getCalendarAvailability(event, includeNextMonth);
                    }
                    else this.toastr.error("Agenda No disponible");
                }
            }
        });
    }
    public getAvailabilityinNextMonth(month, year) {
        var init_date = `${month}-01-${year}`;
        var end_date = `${month}-31-${year}`;
        var daysInMonth = new Date(year, month, 0).getDate();
        this.bookingService.getAvailabilityByPlantAndMonth(init_date, end_date).subscribe((response) => {
            if (response.message && response.status) {
                this.maximumDate = { year: year, month: month, day: daysInMonth };
            }
        });
    }

    /* Disables holydays and looks for availability of booking for rfest of the days */
    pickUpDate(event) {
        var month = event.month + 1;
        var year = event.year;
        if (month > 12) {
            month = 1;
            year += 1;
        }
        this.getAvailabilityinNextMonth(month, year);
        this.getCalendarAvailability(event);

    }

    /* Disable days based on the ms mandatory returned days */
    public isDisabled(availableDays, year, month) {
        const daysOfMonth = new Date(year, month, 0).getDate(); // This returns the total days of the month (number)
        const disabledDates: NgbDateStruct[] = [];
        /* This finds and push to the disabled days all sundays */
        for (let i = 0; daysOfMonth >= i; i++) {
            const date = new Date(year, month - 1, i);
            if (date.getDay() === 0) {
                disabledDates.push({ year, month, day: date.getDate() });
            }
        }
        /* This looks for all holydays that comes in the not-worked-days service */
        availableDays.message.days.forEach(element => {
            disabledDates.push({ year, month, day: element.day });
        });
        /* Then the disabled days are set */
        this.disabledDays = (dateStruct: NgbDateStruct) => {
            return disabledDates.find(date => new NgbDate(date.year, date.month, date.day).equals(dateStruct));
        };
    }
    goBookingByDate() {
        if (this.dateModel !== undefined) {
            this.ngxLoader.startLoader('selectType-loader');
            gtag('event', 'Reserva4', { 'event_category': 'Reserva4', 'event_label': 'Reserva4', 'value': 'Reserva4' });
            const date = (`${this.dateModel.year}-${this.dateModel.month}-${this.dateModel.day}`);
            this.myMoment = moment.utc(date, 'YYYY-MM-DD').format();
            this.bookingService.getBookingAvailability(this.myMoment).subscribe(
                response => {
                    this.ngxLoader.stopBackground('selectType-loader');
                    if (response.status === true) {
                        for (var key in response.message) {
                            response.message[key].rangeOfHours = response.message[key].rangeOfHours.filter(hour => hour.totalForReservation > hour.reservated);
                        }
                        this.bookingService.setAvailability(response.message);
                        this.activeModal.close();
                        this.router.navigateByUrl('/booking/select-datetime');
                    }
                }
            );
        }
    }
}